import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewReperksOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reperks-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewReperksConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reperks-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewReperksMemberActivities(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reperks-member-activities`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewReperksAnalytics(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reperks-analytics`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewReperksSettingsShforms() {
  return `view/extensions/reperks-settings-shforms`;
}

export function getViewReperksSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperksSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewReperksWidgetEditor() {
  return `view/extensions/reperks-widget-editor`;
}

export function getViewReperksWidgetEditor(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperksWidgetEditor(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewReperksEmailsEditor() {
  return `view/extensions/reperks-emails-editor`;
}

export function getViewReperksEmailsEditor(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperksEmailsEditor(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathReperksMerchants() {
  return `extensions/reperks-merchants`;
}

export function patchReperksMerchants(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathReperksMerchants(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export const URL_REPERKS_EMAIL_LOGO_MEDIA = `/${constants.API_VERSION}/extensions/reperks/email-logo-media`;

export function getViewManageReperksEmails(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-emails`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResendReperksEmailRecipients(successCallback, errorCallback, recipientId) {
  postAuth({
    "path": `extensions/reperks-email-recipients/${recipientId}/resend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}


// Rewards
export function getViewManageReperksRewards(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-rewards`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewReperksRewardShforms(rewardId=null) {
  if (rewardId) {
      return `view/extensions/reperks-reward-shforms/${rewardId}`;
  } else {
      return `view/extensions/reperks-reward-shforms`;
  }
}

export function getViewReperksRewardShforms(successCallback, errorCallback, rewardId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperksRewardShforms(rewardId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathReperksRewards(rewardId=null) {
  if (rewardId) {
      return `extensions/reperks-rewards/${rewardId}`;
  } else {
      return `extensions/reperks-rewards`;
  }
}

export function createReperksRewards(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReperksRewards(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReperksRewards(successCallback, errorCallback, data, rewardId) {
  patchAuth({
    "path": pathReperksRewards(rewardId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReperksRewards(successCallback, errorCallback, rewardId) {
  deleteAuth({
    "path": pathReperksRewards(rewardId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderReperksRewards(successCallback, errorCallback, data, rewardId) {
  postAuth({
    "path": `extensions/reperks-rewards/${rewardId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function resyncReperksRewardCoupons(successCallback, errorCallback, rewardId) {
  postAuth({
    "path": `extensions/reperks-rewards/${rewardId}/resync-coupons`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": {}
  });
}

export function getViewManageReperksRewardCoupons(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-reward-coupons`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlUploadReperksRewardCoupons(rewardId) {
  return `/${constants.API_VERSION}/extensions/reperks-rewards/${rewardId}/upload-coupons`;
}

// Members
function pathReperksMembers(memberId=null) {
  if (memberId) {
      return `extensions/reperks-members/${memberId}`;
  } else {
      return `extensions/reperks-members`;
  }
}

export function patchReperksMembers(successCallback, errorCallback, data, memberId) {
  patchAuth({
    "path": pathReperksMembers(memberId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

function pathViewReperkMemberProfileShforms(memberId) {
  return `view/extensions/reperks-member-profile-shforms/${memberId}`;
}

export function getViewReperksMemberProfileShforms(successCallback, errorCallback, memberId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperkMemberProfileShforms(memberId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postReperksMemberPointsAdjustment(successCallback, errorCallback, data, memberId) {
  postAuth({
    "path": `extensions/reperks-members/${memberId}/points-adjustment`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postReperksMemberEditBirthday(successCallback, errorCallback, data, memberId) {
  postAuth({
    "path": `extensions/reperks-members/${memberId}/edit-birthday`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewManageReperksMembers(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-members`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageReperksActivities(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-activities`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Coupons
function pathReperksCoupons(couponId=null) {
  if (couponId) {
      return `extensions/reperks-coupons/${couponId}`;
  } else {
      return `extensions/reperks-coupons`;
  }
}

export function createReperksCoupons(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReperksCoupons(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReperksCoupons(successCallback, errorCallback, data, couponId) {
  patchAuth({
    "path": pathReperksCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReperksCoupons(successCallback, errorCallback, couponId) {
  deleteAuth({
    "path": pathReperksCoupons(couponId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Activity
function pathReperksActivities(activityId=null) {
  if (activityId) {
      return `extensions/reperks-activities/${activityId}`;
  } else {
      return `extensions/reperks-activities`;
  }
}

export function listReperksActivities(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathReperksActivities(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getReperksActivities(successCallback, errorCallback, activityId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathReperksActivities(activityId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function patchReperksActivities(successCallback, errorCallback, data, activityId) {
  patchAuth({
    "path": pathReperksActivities(activityId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


// Activity Rule
export function getViewManageReperksActivityRules(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reperks-activity-rules`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewReperksActivityRuleShforms(ruleId=null) {
  if (ruleId) {
      return `view/extensions/reperks-activity-rule-shforms/${ruleId}`;
  } else {
      return `view/extensions/reperks-activity-rule-shforms`;
  }
}

export function getViewReperksActivityRuleShforms(successCallback, errorCallback, ruleId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReperksActivityRuleShforms(ruleId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathReperksActivityRules(ruleId=null) {
  if (ruleId) {
      return `extensions/reperks-activity-rules/${ruleId}`;
  } else {
      return `extensions/reperks-activity-rules`;
  }
}

export function createReperksActivityRules(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReperksActivityRules(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReperksActivityRules(successCallback, errorCallback, data, ruleId) {
  patchAuth({
    "path": pathReperksActivityRules(ruleId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReperksActivityRules(successCallback, errorCallback, ruleId) {
  deleteAuth({
    "path": pathReperksActivityRules(ruleId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function reorderReperksActivityRules(successCallback, errorCallback, data, ruleId) {
  postAuth({
    "path": `extensions/reperks-activity-rules/${ruleId}/reorder`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

// Widget
function pathReperksWidgetThemes(themeId=null) {
  if (themeId) {
      return `extensions/reperks-widget-themes/${themeId}`;
  } else {
      return `extensions/reperks-widget-themes`;
  }
}

export function createReperksWidgetThemes(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReperksWidgetThemes(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReperksWidgetThemes(successCallback, errorCallback, data, themeId) {
  patchAuth({
    "path": pathReperksWidgetThemes(themeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteReperksWidgetThemes(successCallback, errorCallback, themeId) {
  deleteAuth({
    "path": pathReperksWidgetThemes(themeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
